<template>
    <div class="p-3" color="light">
        <v-card>
            <v-col>
                <div class="d-flex">
                    <h5>Integration Wiki</h5>
                    <v-spacer></v-spacer>
                    <v-btn class="float-right" small :color="editColor" @click="toggleEditing" v-show="!is_disabled && isAdmin">{{  editBtnText }}</v-btn>
                </div>

                <v-form
                    ref="form"
                    :disabled="is_disabled">
                    <v-container fluid>
                        <div>
                            <v-row class="grey lighten-5 mb-1">
                                <v-col  class="top-0">
                                    <div v-show="isViewing && (form === '' || form === null)">
                                        <p class="text-center">No Information Added.</p>
                                    </div>
                                    <div v-if="is_disabled" v-html="form"></div>
                                    <div v-else-if="!is_disabled && isViewing" v-html="form"></div>
                                    <div v-else>
                                        <tinyMCE
                                            :note="form"
                                            :integration_id="integrationId"
                                            platform_id=0
                                        />
                                    </div>
                                </v-col>
                                <v-col md="12" class="pt-5" v-if="!isViewing">
                                    <span class="my-5">
                                        <H5>Add New Change</H5>
                                    </span>
                                    <v-textarea
                                        v-model="additional_log"
                                        dense
                                        outlined
                                        hide-details
                                        clear-icon="mdi-close-circle"
                                        auto-grow
                                        label="Change Notes"
                                        value="Change Notes">
                                    </v-textarea>
                                </v-col>
                                <div class="d-flex pb-10"  v-if="!is_disabled && isAdmin && !isViewing">
                                    <v-spacer></v-spacer>
                                    <v-btn small color="primary" @click="onSubmit" :disabled="isSubmit">
                                        <span v-if="isSubmit">
                                            <v-progress-circular
                                            indeterminate
                                                size="12"
                                                width="2"
                                            color="green darken-3">
                                            </v-progress-circular>
                                            saving
                                        </span>
                                        <span v-else>save</span>
                                    </v-btn>
                                </div>
                            </v-row>
                        </div>
                    </v-container>
                </v-form>
                <v-card color="light">
                    <v-col class="mt-0">
                        <b>Logs</b>
                        <notes-logs class="mt-3 record-data" :notes="logs" v-if="logs.length > 0 "></notes-logs>
                        <div v-else>
                            <p class="text-center">No Integration Logs Added.</p>
                        </div>
                    </v-col>
                </v-card>
            </v-col>
        </v-card>


        <v-card class="mt-10">
            <v-col>
                <div class="d-flex">
                    <h5>Platform Wiki</h5>
                    <v-spacer></v-spacer>
                    <v-btn class="float-right" small color="primary"  v-show="isAdmin" :to="'/platforms/' + typeId ">Edit Platform Wiki</v-btn>
                </div>
                <div v-show="platformWiki === '' || platformWiki === null">
                    <p class="text-center">No Information Added.</p>
                </div>
                <div v-html="platformWiki" class="py-5"></div>
                <v-card color="light">
                    <v-col class="mt-0">
                        <b>Logs</b>
                        <notes-logs class="mt-3 record-data" :notes="platformLogs" v-if="platformLogs.length > 0 "></notes-logs>
                        <div v-else>
                            <p class="text-center">No Platform Logs Added.</p>
                        </div>
                    </v-col>
                </v-card>
            </v-col>
        </v-card>


    </div>
</template>

<script>
import { mapGetters } from "vuex"
import { EventBus } from '@/js/event-bus.js'
import tinyMCE from '~/platforms/components/tinyMCEDefault'
import NotesLogs from '~/platforms/components/NotesLogs'

export default {

    components: {
        tinyMCE,
        NotesLogs
    },

    props: {
        integration: { type: Object, default: {}},
        is_disabled: { type: Boolean, default: false }
    },

    computed: {
        ...mapGetters(['isAdmin']),
    },

    data() {
        return {
            form: this.integration.note,
            additional_log: '',
            logs: [],
            isSubmit: false,
            integrationId: null,
            typeId: this.integration.integration_type_id,
            editColor: 'primary',
            isViewing: true,
            editBtnText: 'Edit Integration WIki',
            platformWiki: '',
            platformLogs: []
        }
    },

    mounted() {
        if (!this.integrationId) {
            this.integrationId = this.$route.params.id;
            this.platformNotes()
            this.noteLogs()
        }
    },

    methods: {
        platformNotes() {
            this.$http
                .get('/api/integrationtypes/' + this.typeId)
                .then(res => {

                    let formData = res.data.data.attributes
                    this.platformWiki = formData.note
                    this.platformLogs = formData.logs
                })
                .catch(err => {
                    EventBus.$emit('show-error', err);
                })
        },

        noteLogs() {
            this.$http
                .get('/api/integrations/note-logs/' + this.integrationId)
                .then(( nlogs ) => {
                    this.logs = nlogs.data
                })
        },

        async onSubmit(e) {
            e.preventDefault();

            // validate
            if (tinymce.activeEditor.getContent() !== null || tinymce.activeEditor.getContent() !== '') {
                this.isSubmit = true
                let data = {
                    note: tinymce.activeEditor.getContent(),
                    additional_log: this.additional_log,
                    label: this.integration.label,
                    account_id: this.integration.account_id,
                    integration_type_id: this.integration.integration_type_id,
                    frequency_mins: this.integration.frequency_mins,
                }

                this.additional_log = ""
                await this.$http
                    .put('/api/integrations/' + this.integrationId, data)
                    .then(({ data }) => {

                        this.noteLogs()

                        let integrationData = data.data.attributes
                        this.form = integrationData.note

                        this.toggleEditing()
                        EventBus.$emit('show-success', 'Successfully saved configurations.')

                    })
                    .catch(err => {
                        EventBus.$emit('show-error', err)
                    })

                this.isSubmit = false

            }
            else {
                EventBus.$emit('show-error', 'Please Fill up all fields')
            }
        },

        toggleEditing(){
            this.isViewing = !this.isViewing
            this.editBtnText = this.isViewing ? 'Edit Integration WIki' : 'Cancel'
            this.editColor = this.isViewing ? 'primary' : ''
        }
    }
}

</script>